<app-page-container [props]="props" [title]="title" (tabChange)="onTabChange($event)"
 class="config-container config-full-height" [layoutType]="LayoutType.Tab" [tabConfig]="tabConfig">
</app-page-container>